import React from "react";
import {useIonAlert} from "@ionic/react";
import {NotificationModalContextProps, NotificationModalContext} from "../contexts/NotificationModalContext";
import './NotificationModalProvider.css';

const NotificationModalProvider = ({children}: any) => {
    const [presentAlert] = useIonAlert();

    const contextArgs: NotificationModalContextProps = {
        showSuccessModal: async (message: string) => {
            await presentAlert({
                header: 'Success',
                message,
                cssClass: ['notification-modal', 'notification-modal-success'],
                translucent: true,
                backdropDismiss: false,
                buttons: [{
                    text: 'OK',
                    cssClass: ['notification-modal-button'],
                    role: 'button',
                }]
            });
        },
        showErrorModal: async (message: string) => {
            await presentAlert({
                header: 'Error',
                message,
                cssClass: ['notification-modal', 'notification-modal-error'],
                translucent: true,
                backdropDismiss: false,
                buttons: [{
                    text: 'OK',
                    cssClass: ['notification-modal-button'],
                    role: 'button',
                }]
            });
        }
    };

    return (
        <NotificationModalContext.Provider value={contextArgs}>
            {children}
        </NotificationModalContext.Provider>
    );
};

export default NotificationModalProvider;
